import { Box, Divider, Typography } from '@mui/material';
import { formatISOToPHT } from '../../utilities/date';

const cardLabelCounterStyle = {
  height: '30px',
  fontWeight: 'bold',
  textAlign: 'center',
};

const dividerStyle = {
  mb: 2,
};

const comparisonFieldSizeStyle = {
  height: '50px',
  maxHeight: '50px',
  overflowY: 'auto',
};

const getTestId = (tag, currentTab, cardIndex, fieldIndex) => {
  return `comparison-${tag}-${currentTab}-card${cardIndex}-${fieldIndex}`;
};

const FieldTypography = ({ label, value, sx, testid }) => {
  return (
    <Typography sx={comparisonFieldSizeStyle} data-testid={testid}>
      {label}: {value}
    </Typography>
  );
};

const EmpAddressFields = ({ address, index, tag, currentTab }) => {
  return (
    <>
      <Typography sx={cardLabelCounterStyle}>Address {index + 1}</Typography>
      <Divider sx={dividerStyle} />
      <FieldTypography
        label="Is Residential"
        value={address.isresidential ? 'True' : 'False'}
        testid={getTestId(tag, currentTab, index, 0)}
      />
      <FieldTypography
        label="Is Permanent"
        value={address.ispermanent ? 'True' : 'False'}
        testid={getTestId(tag, currentTab, index, 1)}
      />
      <FieldTypography
        label="Telephone"
        value={address.telephone}
        testid={getTestId(tag, currentTab, index, 2)}
      />
      <FieldTypography
        label="Unit Number"
        value={address.unitnumber}
        testid={getTestId(tag, currentTab, index, 3)}
      />
      <FieldTypography
        label="Lot Number"
        value={address.lotnumber}
        testid={getTestId(tag, currentTab, index, 4)}
      />
      <FieldTypography
        label="House Bldg. Number"
        value={address.housebldgnum}
        testid={getTestId(tag, currentTab, index, 5)}
      />
      <FieldTypography
        label="Street"
        value={address.street}
        testid={getTestId(tag, currentTab, index, 6)}
      />
      <FieldTypography
        label="Barangay"
        value={address.barangay}
        testid={getTestId(tag, currentTab, index, 7)}
      />
      <FieldTypography
        label="Subdivision"
        value={address.subdivision}
        testid={getTestId(tag, currentTab, index, 8)}
      />
      <FieldTypography
        label="City"
        value={address.city}
        testid={getTestId(tag, currentTab, index, 9)}
      />
      <FieldTypography
        label="Province"
        value={address.province}
        testid={getTestId(tag, currentTab, index, 10)}
      />
      <FieldTypography
        label="Region"
        value={address.region}
        testid={getTestId(tag, currentTab, index, 11)}
      />
      <FieldTypography
        label="ZIP code"
        value={address.zipcode}
        testid={getTestId(tag, currentTab, index, 12)}
      />
      <FieldTypography
        label="Country"
        value={address.country}
        testid={getTestId(tag, currentTab, index, 13)}
      />
    </>
  );
};

const EmpRelationsFields = ({ relation, index, tag, currentTab }) => {
  return (
    <>
      <Typography sx={cardLabelCounterStyle}>Relation {index + 1}</Typography>
      <Divider sx={dividerStyle} />
      <FieldTypography
        label="Last Name"
        value={relation.lastname}
        testid={getTestId(tag, currentTab, index, 0)}
      />
      <FieldTypography
        label="First Name"
        value={relation.firstname}
        testid={getTestId(tag, currentTab, index, 1)}
      />
      <FieldTypography
        label="Middle Name"
        value={relation.middlename}
        testid={getTestId(tag, currentTab, index, 2)}
      />
      <FieldTypography
        label="Occupation"
        value={relation.occupation}
        testid={getTestId(tag, currentTab, index, 3)}
      />
      <FieldTypography
        label="Employer"
        value={relation.employer}
        testid={getTestId(tag, currentTab, index, 4)}
      />
      <FieldTypography
        label="Address"
        value={relation.address}
        testid={getTestId(tag, currentTab, index, 5)}
      />
      <FieldTypography
        label="Telephone"
        value={relation.telephone}
        testid={getTestId(tag, currentTab, index, 6)}
      />
      <FieldTypography
        label="Cellphone"
        value={relation.cellphone}
        testid={getTestId(tag, currentTab, index, 7)}
      />
      <FieldTypography
        label="Date of Birth"
        value={formatISOToPHT(relation.dateofbirth)}
        testid={getTestId(tag, currentTab, index, 8)}
      />
      <FieldTypography
        label="Relationship"
        value={relation.relationship}
        testid={getTestId(tag, currentTab, index, 9)}
      />
      <FieldTypography
        label="Emergency"
        value={relation.emergency ? 'True' : 'False'}
        testid={getTestId(tag, currentTab, index, 10)}
      />
      <FieldTypography
        label="Reference Person"
        value={relation.referenceperson ? 'True' : 'False'}
        testid={getTestId(tag, currentTab, index, 11)}
      />
    </>
  );
};

const EmpEducationFields = ({ education, index, tag, currentTab }) => {
  return (
    <>
      <Typography sx={cardLabelCounterStyle}>Education {index + 1}</Typography>
      <Divider sx={dividerStyle} />
      <FieldTypography
        label="Level"
        value={education.level}
        testid={getTestId(tag, currentTab, index, 0)}
      />
      <FieldTypography
        label="School"
        value={education.school}
        testid={getTestId(tag, currentTab, index, 1)}
      />
      <FieldTypography
        label="Degree"
        value={education.degree}
        testid={getTestId(tag, currentTab, index, 2)}
      />
      <FieldTypography
        label="Graduation Year"
        value={formatISOToPHT(education.gradyear)}
        testid={getTestId(tag, currentTab, index, 3)}
      />
      <FieldTypography
        label="Highest Attained"
        value={education.highestattained}
        testid={getTestId(tag, currentTab, index, 4)}
      />
      <FieldTypography
        label="Start Date"
        value={formatISOToPHT(education.startdate)}
        testid={getTestId(tag, currentTab, index, 5)}
      />
      <FieldTypography
        label="End Date"
        value={formatISOToPHT(education.enddate)}
        testid={getTestId(tag, currentTab, index, 6)}
      />
      <FieldTypography
        label="Honors"
        value={education.honors}
        testid={getTestId(tag, currentTab, index, 7)}
      />
    </>
  );
};

const EmpCivServiceFields = ({ service, index, tag, currentTab }) => {
  return (
    <>
      <Typography sx={cardLabelCounterStyle}>
        Civil Service {index + 1}
      </Typography>
      <Divider sx={dividerStyle} />
      <FieldTypography
        label="Service Type"
        value={service.servicetype}
        testid={getTestId(tag, currentTab, index, 0)}
      />
      <FieldTypography
        label="Rating"
        value={service.rating}
        testid={getTestId(tag, currentTab, index, 1)}
      />
      <FieldTypography
        label="License Number"
        value={service.licensenumber}
        testid={getTestId(tag, currentTab, index, 2)}
      />
      <FieldTypography
        label="Date of Exam"
        value={formatISOToPHT(service.dateofexam)}
        testid={getTestId(tag, currentTab, index, 3)}
      />
      <FieldTypography
        label="Date of Release"
        value={formatISOToPHT(service.dateofrelease)}
        testid={getTestId(tag, currentTab, index, 4)}
      />
    </>
  );
};

const EmpWorkExpFields = ({ work, index, tag, currentTab }) => {
  return (
    <>
      <Typography sx={cardLabelCounterStyle}>
        Work Experience {index + 1}
      </Typography>
      <Divider sx={dividerStyle} />
      <FieldTypography
        label="Start Date"
        value={formatISOToPHT(work.startdate)}
        testid={getTestId(tag, currentTab, index, 0)}
      />
      <FieldTypography
        label="End Date"
        value={formatISOToPHT(work.enddate)}
        testid={getTestId(tag, currentTab, index, 1)}
      />
      <FieldTypography
        label="Position"
        value={work.position}
        testid={getTestId(tag, currentTab, index, 2)}
      />
      <FieldTypography
        label="Place of Employment"
        value={work.placeofemployment}
        testid={getTestId(tag, currentTab, index, 3)}
      />
      <FieldTypography
        label="Monthly Salary"
        value={work.monthlysalary}
        testid={getTestId(tag, currentTab, index, 4)}
      />
      <FieldTypography
        label="Status"
        value={work.status}
        testid={getTestId(tag, currentTab, index, 5)}
      />
      <FieldTypography
        label="Government"
        value={work.government ? 'True' : 'False'}
        testid={getTestId(tag, currentTab, index, 6)}
      />
    </>
  );
};

const EmpCivicWorkFields = ({ civwork, index, tag, currentTab }) => {
  return (
    <>
      <Typography sx={cardLabelCounterStyle}>Civic Work {index + 1}</Typography>
      <Divider sx={dividerStyle} />
      <FieldTypography
        label="Organization Name"
        value={civwork.organizationname}
        testid={getTestId(tag, currentTab, index, 0)}
      />
      <FieldTypography
        label="Address"
        value={civwork.address}
        testid={getTestId(tag, currentTab, index, 1)}
      />
      <FieldTypography
        label="Start Date"
        value={formatISOToPHT(civwork.startdate)}
        testid={getTestId(tag, currentTab, index, 2)}
      />
      <FieldTypography
        label="End Date"
        value={formatISOToPHT(civwork.enddate)}
        testid={getTestId(tag, currentTab, index, 3)}
      />
      <FieldTypography
        label="Hours"
        value={civwork.hours}
        testid={getTestId(tag, currentTab, index, 4)}
      />

      <FieldTypography
        label="Position"
        value={civwork.position}
        testid={getTestId(tag, currentTab, index, 5)}
      />
    </>
  );
};

const EmpTrainingFields = ({ training, index, tag, currentTab }) => {
  return (
    <>
      <Typography sx={cardLabelCounterStyle}>Training {index + 1}</Typography>
      <Divider sx={dividerStyle} />
      <FieldTypography
        label="Title"
        value={training.trainingtitle}
        testid={getTestId(tag, currentTab, index, 0)}
      />
      <FieldTypography
        label="Sponsor"
        value={training.sponsor}
        testid={getTestId(tag, currentTab, index, 1)}
      />
      <FieldTypography
        label="Start Date"
        value={formatISOToPHT(training.startdate)}
        testid={getTestId(tag, currentTab, index, 2)}
      />
      <FieldTypography
        label="End Date"
        value={formatISOToPHT(training.enddate)}
        testid={getTestId(tag, currentTab, index, 3)}
      />
      <FieldTypography
        label="Hours"
        value={training.hours}
        testid={getTestId(tag, currentTab, index, 4)}
      />
    </>
  );
};

export const EditRequestFieldCard = (props) => {
  const currentTab = props.activeTab;

  return (
    <>
      {props.activeRows.map((item, index) => (
        <Box
          sx={{
            bgcolor: '#212c3f',
            mb: 2,
            borderRadius: '5px',
            px: 2,
            pt: 2,
            boxShadow: '5px 5px 5px rgba(0, 0, 0, 0.1)',
          }}
          key={index}
        >
          {/* EMPLOYEE ADDRESS FIELDS */}
          {currentTab === 'empaddress' && (
            <EmpAddressFields
              address={item}
              index={index}
              tag={props.tag}
              currentTab={currentTab}
            />
          )}

          {/* EMPLOYEE RELATIONS FIELDS */}
          {currentTab === 'emprelations' && (
            <EmpRelationsFields
              relation={item}
              index={index}
              tag={props.tag}
              currentTab={currentTab}
            />
          )}

          {/* EMPLOYEE EDUCATION FIELDS */}
          {currentTab === 'empeducation' && (
            <EmpEducationFields
              education={item}
              index={index}
              tag={props.tag}
              currentTab={currentTab}
            />
          )}

          {/* EMPLOYEE CIVIL SERVICE FIELDS */}
          {currentTab === 'empcivservice' && (
            <EmpCivServiceFields
              service={item}
              index={index}
              tag={props.tag}
              currentTab={currentTab}
            />
          )}

          {/* EMPLOYEE WORK EXPERIENCE FIELDS */}
          {currentTab === 'empworkexp' && (
            <EmpWorkExpFields
              work={item}
              index={index}
              tag={props.tag}
              currentTab={currentTab}
            />
          )}

          {/* EMPLOYEE CIVIC WORK FIELDS */}
          {currentTab === 'empcivicwork' && (
            <EmpCivicWorkFields
              civwork={item}
              index={index}
              tag={props.tag}
              currentTab={currentTab}
            />
          )}

          {/* EMPLOYEE TRAINING FIELDS */}
          {currentTab === 'emptraining' && (
            <EmpTrainingFields
              training={item}
              index={index}
              tag={props.tag}
              currentTab={currentTab}
            />
          )}
        </Box>
      ))}
    </>
  );
};
